module.exports = __webpack_public_path__ + "media/bookPage/how-it-works-64e0ceab.png";